import { createClient } from "@supabase/supabase-js";

// URL completa (no sólo el id del proyecto) para poder apuntar al Supabase local
// (http://127.0.0.1:54321) o al del proyecto (https://<ref>.supabase.co).
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseKey) {
    throw new Error("Faltan REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_PUBLISHABLE_KEY. Revisa el .env (ver .env.sample).");
}

export const supabaseClient = createClient(supabaseUrl, supabaseKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
    }
});
